import { useMemo } from "react";
import {
  useFilterList as useCoreFilterList,
  useCarsAvailabilityFilters,
} from "@b2bportal/core-cars";

export const useFilterList = () => {
  const coreProps = useCoreFilterList();
  const { handlers } = useCarsAvailabilityFilters();

  const resetFilter = useMemo(() => {
    return {
      resetCancellation: () => handlers.resetCancellationFilter(),
      resetCarTypeFilter: () => handlers.resetCarTypeFilter(),
      resetMinimumBagsFilter: () => handlers.resetMinimumBagsFilter(),
      resetPassengerFilter: () => handlers.resetPassengerFilter(),
      resetPriceFilter: () => handlers.resetPriceFilter(),
      resetSupplierFilter: () => handlers.resetSupplierFilter(),
    };
  }, [handlers]);

  return useMemo(
    () => ({
      ...coreProps,
      handlers: { ...coreProps.handlers, resetFilter },
    }),
    [coreProps, resetFilter]
  );
};
